import React from "react";

function Quote({ showQoute, setshowQoute }) {
  return (
    <div
      className={
        showQoute
          ? "absolute top-0 left-0 z-10 bg-[rgba(0,0,0,0.8)] w-full flex items-center justify-center h-full  "
          : "hidden"
      }
    >
      <div className="">
        <div className="  rounded-[10px] relative left-1/2 -translate-x-1/2 text-center shadow-md bg-[#DCAE96] flex flex-col justify-center items-center text-2xl  text-black p-5  w-[500px] h-[60vh]  z-20 ">
          <img className=" mb-5 " src="/images/Chidimma/🌟.png" alt="" />
          <h3 className="mb-6 mt-2 font-semibold">
            “Success is not final;Failure is not fatal;It is the courage to
            continue that counts” <br />{" "}
            <span className="font-bold">-WINSTON CHURCHILL</span>
          </h3>
          <button onClick={() => setshowQoute(!showQoute)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="black"
              className="w-8 h-8"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Quote;

// import React, { useEffect } from 'react';

// const YourComponent = () => {
//   const category = 'happiness';

//   (() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch(`https://api.api-ninjas.com/v1/quotes?category=${category}`, {
//           method: 'GET',
//           headers: {
//             'X-Api-Key': 'YOUR_API_KEY',
//             'Content-Type': 'application/json',
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const result = await response.json();
//         console.log(result);
//       } catch (error) {
//         console.error('Error: ', error.message);
//       }
//     };

//     fetchData();
//   }, []); // Empty dependency array ensures that the effect runs once after the initial render

//   return (
//     <div>
//       {/* Your component JSX */}
//     </div>
//   );
// };

// export default YourComponent;
